import { IntegrationCode } from 'modules/data/domain';

export const mapTemplateToLearnMoreLink: Partial<Record<IntegrationCode, string>> = {
    [IntegrationCode.XeroCreditNotesPayable]:
        'https://support.approvalmax.com/portal/en/kb/articles/how-do-i-set-up-the-pulling-from-xero-step-for-ap-credit-notes',
    [IntegrationCode.XeroCreditNotesReceivable]:
        'https://support.approvalmax.com/portal/en/kb/articles/how-do-i-set-up-the-pull-from-xero-step-for-credit-notes',
};
